import * as React from 'react';
import { Button, Input, Modal } from '@ixicare/ui';
import { PlaneEntryProps } from '@ixicare/resources';
import { t } from '~i18n';
import { Spacer } from '~components/Utils/Spacer';
import { getFieldError } from '~utils/error';
import { useMutation } from '@tanstack/react-query';
import SiteStore from '~modules/sites/store/Site';

export function UpdateFloorModal({
  onClose,
  floor,
  site,
}: {
  onClose: () => void;
  floor: PlaneEntryProps;
  site: SiteStore;
}) {
  const [floorName, setFloorName] = React.useState(floor.floorName ?? '');
  const [floorNumber, setFloorNumber] = React.useState(floor.floor ?? '');

  const updateMutation = useMutation({
    mutationFn: () =>
      site.updatePlane(floor.id, {
        floorName: floorName,
        floorNumber: floorNumber,
      }),
    onSuccess: () => {
      onClose();
    },
  });

  return (
    <Modal style={{ maxWidth: 450 }}>
      <h3 className="text-center mb-10">{t('siteSettings.floors.update.title')}</h3>
      <Spacer size={32} />
      <Input
        label={t('siteSettings.floors.table.name')}
        value={floorName}
        onValueChange={(x) => {
          setFloorName(x);
        }}
        error={getFieldError('floorName')}
      />
      <Spacer size={32} />
      <Input
        label={t('siteSettings.floors.table.floorNumber')}
        value={floorNumber}
        type="number"
        onValueChange={(x) => {
          setFloorNumber(parseInt(x));
        }}
        error={getFieldError('floorNumber')}
      />
      <Spacer size={32} />
      <div>
        <Button
          className="mb-15 error"
          isBlock
          buttonType="primary"
          type="button"
          onClick={() => updateMutation.mutate()}
        >
          {t('device.form.confirm')}
        </Button>
        <Button onClick={() => onClose()} isBlock buttonType="link">
          {t('global.cancel')}
        </Button>
      </div>
    </Modal>
  );
}
